import {Component, OnInit} from '@angular/core';

export enum TooltipPosition {
    ABOVE = 'above',
    BELOW = 'below',
    LEFT = 'left',
    RIGHT = 'right',
}

@Component({
    selector: 'tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements OnInit {
    position: TooltipPosition = TooltipPosition.ABOVE;
    tooltip: string[]
    left: number = 0;
    top: number = 0;

    constructor() {}

    ngOnInit(): void {}

}